var CryptoJS = require("crypto-js");
var { getCookie, saveCookie } = require("../helpers/general");
var axios = require("axios");
var { useSelector } = require("react-redux");

const CryptData = {
  secret_key: "myprotectkey2020",
};

export const defaultHeaders = () => {
  // console.log("REACT_APP_IP_BACKEND:", process.env.REACT_APP_IP_BACKEND);
  // console.log("REACT_APP_BACKEND_KEY:", process.env.REACT_APP_BACKEND_KEY);
  const banco = ReadDataStorage('BD_SETA_BD')
  const _headers = {
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Methods": "GET, POST, DELETE, OPTIONS",
    key: process.env.REACT_APP_BACKEND_KEY,
    banco
  };

  return _headers
};

export const Crypt = (string) => {
  return CryptoJS.AES.encrypt(string, CryptData.secret_key).toString();
};

export const DeCrypt = (string) => {
  const bytes = CryptoJS.AES.decrypt(string, CryptData.secret_key);
  return bytes.toString(CryptoJS.enc.Utf8);
};

export const TOKEN_KEY = "@seta-token";
export const EMP_DATA = "@seta-empresa";
export const USER_DATA = "@seta-user";
export const USERNAME = "@tpfqtçnnh";

export const getToken = () => ReadDataStorage(TOKEN_KEY);
export const getUserData = () => {
  if (ReadDataStorage(USER_DATA)) return JSON.parse(ReadDataStorage(USER_DATA));
  else return null;
};

export const ReadDataStorage = (variable) => {
  const _result = DeCrypt(localStorage.getItem(variable) || "");


  return _result;
}

export const WriteDataStorage = async (variable, value) => {
  // console.log(`auth.WriteDataStorage(${variable}): `, value);
  localStorage.setItem(variable, Crypt(value.toString()));
};
export const isAuthenticated = () => {
  let user = ReadDataStorage(TOKEN_KEY);
  let emp = ReadDataStorage(EMP_DATA);

  // console.log("auth.isAuthenticated(user): ", user);
  // console.log("auth.isAuthenticated(emp): ", emp);

  return Object.keys(user).length && Object.keys(emp).length;
  // return true
};
export const isAdmin = () => JSON.parse(getToken())["ADMINISTRADOR"] === "SIM";

export function gravarIp() {
  let ip = getCookie({ label: "ip" });
  if (!ip || ip === "10") {
    fetch("https://api.ipify.org?format=json")
      .then((res) => res.json())
      .then((data) => {
        if (data.ip) saveCookie({ label: "ip", content: data.ip });
        // if (!data.ip) throw new Error();
        // else {
        //     saveCookie({ label: 'ip', content: data.ip });
        // }
      })
      .catch((e) => {
        saveCookie({ label: "ip", content: "10" });
      });
  }
}

const _getGeolocation = (content) => {
  let [latitude, longitude] = getCookie({ label: "geolocation" })
    ? getCookie({ label: "geolocation" }).split(",")
    : ["", ""];
  if (!content?.latitude && latitude) {
    content.latitude = latitude;
    content.longitude = longitude;
  }
  if (!content.ip) content.ip = getCookie({ label: "ip" });

  return { latitude, longitude };
};

export const getGeolocation = (content) => {
  let result = content;
  if (content && !content.latitude) {
    let [latitude, longitude] = getCookie({ label: "geolocation" })
      ? getCookie({ label: "geolocation" }).split(",")
      : ["", ""];
    if ((!latitude || latitude == "") && navigator && navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(function (position) {
        latitude = position.coords.latitude;
        longitude = position.coords.longitude;
      });
    }

    result.latitude = latitude;
    result.longitude = longitude;
    content.latitude = latitude;
    content.longitude = longitude;
  }
  return result;
};

export const setSession = ({ obj, key }) => {
  let content = JSON.stringify(obj);

  // console.log("setSession - content: ", content)
  // console.log("setSession - key: ", key)
  localStorage.setItem(key, content);
};

export const getSession = ({ key }) => {
  if (typeof window !== "undefined") {
    let result = JSON.parse(localStorage.getItem(key));

    // console.log("getSession", result)
    return result;
  }

  return false;
};

export const parseComplexJson = () => {
  let complex = localStorage;
  let complexKeys = Object.keys(localStorage);

  let obj = {};

  for (let key of complexKeys) {
    obj[key] = JSON.parse(complex[key]);
  }

  return obj;
};

export const singleJSONTranspile = () => {
  let json = parseComplexJson();
  let obj = {};

  for (let j in json) {
    for (let d in json[j]) {
      obj[d] = json[j][d];
    }
  }

  return obj;
};

export const getData = async ({ uri, signal, content }) => {
  try {
    let send = {
      headers: defaultHeaders(),
    };
    if (content) send["body"] = content;

    // console.log("auth.getData - send: ", send);
    let body = await fetch(uri, send);

    let response = await body;

    return response.json();
  } catch (error) {
    // console.log(error);
  }
};

export const sendData = async ({
  uri,
  content,
  signal,
  method = "POST",
  multipart,
}) => {
  let response;
  if (!content) content = {};
  _getGeolocation(content);
  if (!content.ip) content.ip = getCookie({ label: "ip" });

  const options = {
    method: "POST",
    url: uri,
    headers: defaultHeaders(),
    data: content,
  };
  if (multipart) options["Content-Type"] = "multipart/form-data";


  try {
    // let result = await fetch(uri, options);
    let result = await axios.request(options);

    response = result;
    if (!response)
      response = {}

    if (response) {
      let status = response?.status;
      // Axios já retorna os dados parseados em response.data
      response = response?.data;
      if (response)
        response["_status"] = status;
    }
    // console.log("sendData - content(1): ", response)
  } catch (err) {
    // console.log("sendData(1) - error: ", err);
    // console.log("Dados: \n", content)
    // console.log("uri: \n", uri)


    if (response)
      response["_status"] = 401;
  }

  return response;
};

function logout() {
  // console.log("!!!!! Tah na hora de deslogar !!!!!");
  localStorage.clear();
  // if (rest && rest.alterarUser)
  //   rest.alterarUser(null)
  window.location.reload();
}

export const inactivityTime = (ini = false) => {
  if (localStorage.getItem(TOKEN_KEY) !== null) {
    let TIME_INATIVITY = 30; //-- Tempo de inatividade em minutos
    var time;

    window.onload = resetTimer;
    window.onmousemove = resetTimer;
    window.onkeypress = resetTimer;
    window.onscroll = resetTimer;
    window.onkeydown = resetTimer;

    function resetTimer() {
      clearTimeout(time);
      time = setTimeout(logout, 60000 * TIME_INATIVITY);
    }

    localStorage.setItem("inactivityTime", true);

    if (ini) resetTimer();

    return time;
  }
};
